import { CaptionBold, H3 } from '@comeon/ui';
import { Link } from '~/utils/navigation';
import styled from 'styled-components';
import { FC, type JSX } from 'react';
import Icon, { ICON_CHEVRON_UP } from '../../../../icon';

const Wrapper = styled.header`
	display: flex;
	justify-content: space-between;
`;

const FlexRow = styled.div`
	display: flex;
	align-items: center;
`;

const IconWrapper = styled.span`
	margin-right: 4px;
`;

const H3Supportive = styled.span`
	margin-left: 4px;

	font: inherit;
	font-weight: 400;
	color: var(--main-text-supportive);
`;

const StyledLink = styled(Link)`
	display: flex;
	align-items: center;

	svg {
		margin-left: 4px;
		fill: var(--main-action-icons);
	}
`;

const StyledLabel = styled(CaptionBold)`
	color: var(--main-text-primary);
`;

const ChevronIcon = styled(Icon).attrs({ type: ICON_CHEVRON_UP })`
	transform: rotate(90deg); // point to right
`;

type Props = {
	title: string;
	titleSupportive?: string;
	linkLabel?: string;
	linkPath?: string;
	className?: string;
	iconElement?: JSX.Element;
};

/**
 * Header component for different content which usually called containers. Should be used as a header of sections/articles etc.
 *
 * @param title - Title of the header
 * @param titleSupportive - Subtitle of the header
 * @param linkLabel - Label of the link
 * @param linkPath - Path of the link
 * @param className - Additional class name
 * @param iconElement - Icon element at the start of the header
 */
const SportsbookContentHeader: FC<Props> = ({
	title,
	titleSupportive,
	linkLabel,
	linkPath,
	className,
	iconElement
}) => {
	return (
		<Wrapper className={className}>
			<FlexRow>
				{iconElement && <IconWrapper>{iconElement}</IconWrapper>}
				<H3>
					{title}
					{titleSupportive && <H3Supportive>{titleSupportive}</H3Supportive>}
				</H3>
			</FlexRow>
			{linkLabel && linkPath && (
				<StyledLink href={linkPath}>
					<StyledLabel>{linkLabel}</StyledLabel>
					<ChevronIcon type={ICON_CHEVRON_UP} width="16" height="16" />
				</StyledLink>
			)}
		</Wrapper>
	);
};

export default SportsbookContentHeader;
